// Dienstpagina's (SEO spokes). Elke dienst heeft UNIEKE tekst.
// Prijzen staan centraal in ./pricing.js

export const services = [
  {
    slug: "glasbewassing",
    title: "Glasbewassing",
    category: "schoonmaak",
    icon: "Sparkles",
    image: "action",
    h1: "Glasbewassing voor woningen en bedrijven",
    metaTitle: "Glasbewassing Rosmalen & Den Bosch | Ramen wassen vanaf €35 | Cleven Cleaning",
    metaDescription:
      "Ramen laten wassen in Rosmalen of Den Bosch? Cleven Cleaning wast streeploos met osmosewater, zonder ladders. Vaste glazenwasser, 24 uur vooraf bericht. Bereken direct uw prijs.",
    intro:
      "Streeploos schone ramen zonder er zelf aan te denken. Cleven Cleaning wast de ramen van woningen, VvE's en bedrijfspanden in Rosmalen, Den Bosch en omgeving — periodiek of eenmalig, altijd met bericht vooraf.",
    body: [
      "Wij werken met osmosewater (gedemineraliseerd water) en telescoopstelen tot 12 meter. Daardoor drogen uw ramen streeploos op zonder zeepresten, en hoeven wij geen ladders tegen uw gevel te plaatsen. Kozijnen en lijsten nemen wij standaard mee.",
      "De meeste klanten kiezen voor een vast schema van elke 6 tot 8 weken. U hoeft niets te onthouden: ons planningssysteem plant de beurt automatisch in en stuurt minimaal 24 uur vooraf een bericht. Niet thuis? Voor de buitenzijde hoeft u niet aanwezig te zijn.",
    ],
    benefits: [
      { title: "Streeploos met osmosewater", text: "Zuiver water zonder kalk of zeep: uw ramen drogen vlekvrij op en blijven langer schoon." },
      { title: "Veilig zonder ladders", text: "Met telescoopstelen tot 12 meter werken wij vanaf de grond — geen ladders tegen uw gevel." },
      { title: "Vaste glazenwasser", text: "Altijd een bekend gezicht dat uw woning en wensen kent." },
      { title: "Binnen én buiten", text: "Ook de binnenzijde, serres en dakramen nemen wij desgewenst mee." },
    ],
    faq: [
      { q: "Moet ik thuis zijn als de glazenwasser komt?", a: "Voor de buitenzijde niet. Zorg alleen dat de poort of tuin bereikbaar is. Voor de binnenzijde maken wij vooraf een afspraak op een moment dat u thuis bent." },
      { q: "Wassen jullie ook de binnenkant van de ramen?", a: "Ja. De binnenzijde doen wij op afspraak, vaak gecombineerd met een buitenbeurt voor een scherp gecombineerd tarief." },
      { q: "Wat gebeurt er als het regent?", a: "Lichte regen is geen probleem: osmosewater droogt streeploos op, ook bij motregen. Bij zware regen, storm of vorst verplaatsen wij de beurt en krijgt u daarover bericht." },
    ],
    related: ["kozijnen-reinigen", "zonnepanelen-reinigen", "dakgoten-leeghalen"],
  },
  {
    slug: "zonnepanelen-reinigen",
    title: "Zonnepanelen reinigen",
    category: "schoonmaak",
    icon: "Sun",
    image: "hero",
    h1: "Zonnepanelen reinigen voor maximaal rendement",
    metaTitle: "Zonnepanelen reinigen Rosmalen & Den Bosch | Cleven Cleaning",
    metaDescription:
      "Vuile zonnepanelen leveren tot 15% minder op. Cleven Cleaning reinigt uw panelen krasvrij met osmosewater in Rosmalen, Den Bosch en omgeving. Bereken direct uw prijs.",
    intro:
      "Vuile zonnepanelen leveren tot 10–15% minder op. Wij reinigen uw panelen veilig met osmosewater en zachte borstels — zonder krassen, zonder chemicaliën — in Rosmalen, Den Bosch en omgeving.",
    body: [
      "Stof, pollen, vogelpoep en groene aanslag vormen een film op uw panelen die zonlicht tegenhoudt. Regen spoelt dit niet weg; het laat juist kalkresten achter. Met gedemineraliseerd water en speciale zachte borstels verwijderen wij alle aanslag zonder de coating van uw panelen te beschadigen.",
      "Wij adviseren één tot twee reinigingen per jaar, bij voorkeur in het voorjaar vóór de zonnige maanden. Combineer het met uw glasbewassing en profiteer van een combinatietarief.",
    ],
    benefits: [
      { title: "Tot 15% meer opbrengst", text: "Schone panelen vangen meer licht. De reiniging verdient zichzelf meestal binnen een seizoen terug." },
      { title: "Krasvrij en chemievrij", text: "Alleen osmosewater en zachte borstels — veilig voor de coating en garantie van uw panelen." },
      { title: "Veilig op hoogte", text: "Vanaf de grond met telescoopstelen of veilig gezekerd op het dak." },
      { title: "Combineren met ramen", text: "Plan het samen met uw glasbewassing en betaal minder." },
    ],
    faq: [
      { q: "Hoe vaak moeten zonnepanelen gereinigd worden?", a: "Voor de meeste daken in Brabant is één keer per jaar voldoende, bij veel bomen, landbouw of een drukke weg in de buurt adviseren wij twee keer per jaar." },
      { q: "Kan het reinigen mijn panelen beschadigen?", a: "Nee. Wij gebruiken geen hogedruk, schuurmiddelen of chemicaliën, alleen gedemineraliseerd water en zachte borstels die speciaal voor zonnepanelen zijn gemaakt." },
      { q: "Merk ik echt verschil in opbrengst?", a: "Ja. Bij zichtbaar vervuilde panelen zien klanten na reiniging vaak 5 tot 15% meer opbrengst in hun omvormer-app." },
    ],
    related: ["glasbewassing", "dak-reinigen", "dakgoten-leeghalen"],
  },
  {
    slug: "kozijnen-reinigen",
    title: "Kozijnen reinigen",
    category: "schoonmaak",
    icon: "Frame",
    image: "action",
    h1: "Kozijnen reinigen voor een frisse uitstraling",
    metaTitle: "Kozijnen reinigen Rosmalen & Den Bosch | Cleven Cleaning",
    metaDescription:
      "Grondige reiniging van kunststof, aluminium en houten kozijnen in Rosmalen, Den Bosch en omgeving. Inclusief sponningen en dorpels. Vraag direct een prijs aan bij Cleven Cleaning.",
    intro:
      "Schone ramen verdienen schone kozijnen. Wij reinigen kunststof, aluminium en houten kozijnen grondig, inclusief sponningen en dorpels, zodat uw woning er weer verzorgd uitziet.",
    body: [
      "Kozijnen vangen jaar in jaar uit regen, stof en uitlaatgassen. Vooral witte kunststof kozijnen worden dof en grauw. Met een milde reiniger en zacht materiaal halen wij de aanslag eraf zonder het oppervlak te beschadigen, zodat uw kozijnen weer helder wit of strak glanzend zijn.",
      "Een grondige kozijnreiniging adviseren wij één tot twee keer per jaar, ideaal in combinatie met uw glasbewassing. Bij een periodiek schema houden wij de kozijnen bovendien standaard bij.",
    ],
    benefits: [
      { title: "Alle materialen", text: "Kunststof, aluminium, hout en gecoat staal — elk materiaal krijgt de juiste behandeling." },
      { title: "Inclusief sponningen", text: "Ook de sponningen, dorpels en ventilatieroosters nemen wij mee." },
      { title: "Langer mooi", text: "Regelmatig reinigen voorkomt inwerking van vuil en verlengt de levensduur." },
      { title: "Voordelig gecombineerd", text: "Samen met glasbewassing plannen scheelt in de prijs." },
    ],
    faq: [
      { q: "Kunnen vergeelde kunststof kozijnen weer wit worden?", a: "Oppervlakkige vergrauwing en aanslag verwijderen wij volledig. Diepe vergeling door UV is een verkleuring van het materiaal zelf; daarvoor adviseren wij eerlijk wat haalbaar is." },
      { q: "Gebruiken jullie agressieve schoonmaakmiddelen?", a: "Nee. Wij gebruiken milde, biologisch afbreekbare reinigers die veilig zijn voor kozijn, kit en beplanting." },
      { q: "Doen jullie ook de binnenkant van de kozijnen?", a: "Ja, op afspraak nemen wij ook de binnenzijde mee." },
    ],
    related: ["glasbewassing", "houtwerk-reinigen", "gevelreiniging"],
  },
  {
    slug: "houtwerk-reinigen",
    title: "Houtwerk reinigen",
    category: "schoonmaak",
    icon: "TreeDeciduous",
    image: "vans",
    h1: "Houtwerk reinigen: boeidelen, gevelbekleding en overstekken",
    metaTitle: "Houtwerk reinigen Rosmalen & Den Bosch | Cleven Cleaning",
    metaDescription:
      "Vakkundige reiniging van boeidelen, houten gevelbekleding en overstekken in Rosmalen en Den Bosch. Verwijdert groene aanslag en vuil zonder het hout te beschadigen.",
    intro:
      "Houten boeidelen, gevelbekleding en overstekken krijgen het zwaar te verduren. Wij reinigen uw houtwerk vakkundig, verwijderen groene aanslag en vuil, en zorgen dat het hout er weer verzorgd uitziet.",
    body: [
      "Groene aanslag en vuil op houtwerk zijn niet alleen lelijk; ze houden vocht vast en versnellen het verval van de verf- of beitslaag. Door het houtwerk periodiek te reinigen, blijft de bescherming intact en stelt u een dure schilderbeurt uit.",
      "Wij werken zonder hogedruk op geschilderd hout, met milde reinigers en zacht materiaal, zodat de verflaag onbeschadigd blijft. Ook het houtwerk hoog op de gevel bereiken wij veilig met telescoopstelen.",
    ],
    benefits: [
      { title: "Beschermt de verflaag", text: "Zachte reiniging zonder hogedruk, veilig voor verf en beits." },
      { title: "Voorkomt houtrot", text: "Geen vuil dat vocht vasthoudt, dus minder kans op schade." },
      { title: "Tot 12 meter hoog", text: "Boeidelen en overstekken bereiken wij zonder steiger of ladder." },
      { title: "Uitstel van schilderwerk", text: "Schoon hout gaat langer mee — dat scheelt in onderhoudskosten." },
    ],
    faq: [
      { q: "Reinigen jullie ook onbehandeld hout zoals lariks of douglas?", a: "Ja. Onbehandeld hout reinigen wij met een speciale behandeling tegen groene aanslag, afgestemd op de houtsoort." },
      { q: "Is reinigen vóór het schilderen verstandig?", a: "Zeker. Een schone, ontvette ondergrond zorgt dat nieuwe verf beter hecht. Veel schilders vragen hier specifiek om." },
      { q: "Hoe vaak moet houtwerk gereinigd worden?", a: "Eén keer per jaar is voor de meeste woningen voldoende; op schaduwrijke, vochtige plekken kan twee keer per jaar nodig zijn." },
    ],
    related: ["kozijnen-reinigen", "gevelreiniging", "dakgoten-leeghalen"],
  },
  {
    slug: "dakgoten-leeghalen",
    title: "Dakgoten leeghalen",
    category: "schoonmaak",
    icon: "Droplets",
    image: "vans",
    h1: "Dakgoten leeghalen en reinigen",
    metaTitle: "Dakgoten leeghalen Rosmalen & Den Bosch | Cleven Cleaning",
    metaDescription:
      "Verstopte dakgoot? Cleven Cleaning haalt uw dakgoten leeg en controleert de afvoeren in Rosmalen, Den Bosch en omgeving. Voorkom lekkage en vochtschade. Vraag direct een prijs aan.",
    intro:
      "Verstopte dakgoten zorgen voor overlopend water, vochtplekken en lekkages. Wij halen uw dakgoten leeg, controleren de afvoeren en nemen het vuil mee — het liefst in het najaar en voorjaar.",
    body: [
      "Bladeren, mos en dakgruis hopen zich op in de goot en blokkeren de afvoer. Bij een flinke regenbui loopt de goot dan over, met natte gevels, vochtige spouwmuren en zelfs lekkage tot gevolg. Twee keer per jaar leeghalen voorkomt dit.",
      "Wij verwijderen alle vuil handmatig of met speciale gootreinigers, spoelen de goot en afvoeren door en signaleren direct losse beugels of lekkende naden. Het vuil nemen wij mee, zodat u er geen werk aan heeft.",
    ],
    benefits: [
      { title: "Voorkomt waterschade", text: "Vrije afvoer betekent geen overlopende goten en natte muren." },
      { title: "Controle van de afvoer", text: "Wij spoelen de hemelwaterafvoer door en melden gebreken." },
      { title: "Vuil nemen wij mee", text: "Geen zakken bladeren in uw tuin: alles wordt afgevoerd." },
      { title: "Veilig zonder ladders", text: "Met gootreinigers op telescoopstelen werken wij veilig vanaf de grond." },
    ],
    faq: [
      { q: "Wanneer is het beste moment om dakgoten leeg te halen?", a: "In het late najaar, nadat de bladeren zijn gevallen, en in het voorjaar na de bloesem. Bij veel bomen adviseren wij beide momenten." },
      { q: "Reinigen jullie ook de buitenkant van de dakgoot?", a: "Ja. De buitenzijde van zinken of kunststof goten reinigen wij desgewenst mee, zodat ook de aanslag en strepen verdwijnen." },
      { q: "Plaatsen jullie ook bladvangers of gootbescherming?", a: "Op verzoek plaatsen wij bladvangers in de afvoer. Volledige gootbescherming adviseren wij per situatie." },
    ],
    related: ["dak-reinigen", "glasbewassing", "gevelreiniging"],
  },
  {
    slug: "dak-reinigen",
    title: "Dak reinigen",
    category: "schoonmaak",
    icon: "Home",
    image: "action",
    h1: "Dak reinigen: mos en algen verwijderen",
    metaTitle: "Dak reinigen & mos verwijderen Rosmalen, Den Bosch | Cleven Cleaning",
    metaDescription:
      "Mos en algen op uw dak? Cleven Cleaning reinigt dakpannen veilig en behandelt tegen nieuwe aanslag in Rosmalen, Den Bosch en omgeving. Langere levensduur, mooiere uitstraling.",
    intro:
      "Mos, algen en vuil op uw dak zien er niet alleen onverzorgd uit; ze houden vocht vast en verkorten de levensduur van uw dakpannen. Wij reinigen uw dak veilig en behandelen het tegen nieuwe aanslag.",
    body: [
      "Mos groeit vooral op de schaduwzijde van het dak en tussen de pannen. Het houdt vocht vast, waardoor pannen bij vorst kunnen barsten en de goot sneller verstopt raakt. Een schoon dak voert regenwater beter af en ziet er jaren jonger uit.",
      "Afhankelijk van het type dakbedekking werken wij met lage druk, speciale borstels of een mosdodende behandeling. Zo verwijderen wij de aanslag zonder de pannen of de coating te beschadigen. Desgewenst behandelen wij het dak na met een preventief middel tegen nieuwe groei.",
    ],
    benefits: [
      { title: "Langere levensduur", text: "Geen mos dat vocht vasthoudt, dus minder kans op vorstschade." },
      { title: "Passende methode", text: "Lage druk of chemische behandeling, afgestemd op uw dakpannen." },
      { title: "Preventieve nabehandeling", text: "Blijft jaren langer schoon dankzij een mosremmende behandeling." },
      { title: "Dakgoten meteen mee", text: "Wij halen de goten direct leeg, zodat losgekomen mos de afvoer niet verstopt." },
    ],
    faq: [
      { q: "Is hogedruk niet slecht voor dakpannen?", a: "Hogedruk kan de toplaag van betonpannen beschadigen. Daarom werken wij met lage druk, borstels of een biologische behandeling, afhankelijk van het type pan." },
      { q: "Hoe lang blijft een dak schoon na reiniging?", a: "Met een preventieve nabehandeling gemiddeld 3 tot 5 jaar, afhankelijk van ligging en schaduw." },
      { q: "Kunnen jullie ook een dak met zonnepanelen reinigen?", a: "Ja. Wij reinigen rondom de panelen en nemen de panelen zelf desgewenst direct mee." },
    ],
    related: ["dakgoten-leeghalen", "zonnepanelen-reinigen", "gevelreiniging"],
  },
  {
    slug: "terras-reinigen",
    title: "Terras reinigen",
    category: "hogedruk",
    icon: "LayoutGrid",
    image: "vans",
    h1: "Terras reinigen met hogedruk",
    metaTitle: "Terras reinigen Rosmalen & Den Bosch | Hogedrukreiniging | Cleven Cleaning",
    metaDescription:
      "Groene aanslag en vlekken op uw terras? Cleven Cleaning reinigt tegels, natuursteen en hout met professionele hogedrukapparatuur in Rosmalen, Den Bosch en omgeving.",
    intro:
      "Groene aanslag, mos en vlekken maken uw terras glad en onverzorgd. Met professionele hogedrukapparatuur en de juiste voorbehandeling ligt uw terras er weer strak bij — klaar voor het zonnige seizoen.",
    body: [
      "Wij reinigen betontegels, keramische tegels, natuursteen en houten vlonders. Elk materiaal vraagt om een eigen druk en techniek: natuursteen en hout reinigen wij met een vlakreiniger op lagere druk, zodat het oppervlak intact blijft en er geen strepen ontstaan.",
      "Na het reinigen spoelen wij het terras schoon en kunnen wij het behandelen tegen nieuwe groene aanslag. Zo blijft uw terras langer veilig en schoon.",
    ],
    benefits: [
      { title: "Streepvrij resultaat", text: "Met een vlakreiniger in plaats van een losse spuitlans: gelijkmatig schoon." },
      { title: "Materiaalveilig", text: "Druk en techniek afgestemd op tegels, natuursteen of hout." },
      { title: "Niet meer glad", text: "Groene aanslag weg, dus een veilig terras voor kinderen en ouderen." },
      { title: "Preventieve behandeling", text: "Optioneel nabehandelen tegen algen en mos." },
    ],
    faq: [
      { q: "Kan hogedruk mijn tegels beschadigen?", a: "Bij verkeerde druk wel. Daarom stemmen wij de druk af op het materiaal en gebruiken wij een vlakreiniger, die de druk gelijkmatig verdeelt." },
      { q: "Moet ik het voegzand daarna aanvullen?", a: "Bij tegels op zand spoelt er altijd wat voegzand weg. Wij vegen na afloop nieuw voegzand in, zodat de tegels stabiel blijven." },
      { q: "Wanneer is de beste tijd voor terrasreiniging?", a: "Het voorjaar, zodat u het hele seizoen van een schoon terras geniet. Ook in het najaar is het zinvol om gladheid te voorkomen." },
    ],
    related: ["oprit-reinigen", "schutting-reinigen", "gevelreiniging"],
  },
  {
    slug: "oprit-reinigen",
    title: "Oprit reinigen",
    category: "hogedruk",
    icon: "Car",
    image: "vans",
    h1: "Oprit reinigen: klinkers, tegels en beton weer als nieuw",
    metaTitle: "Oprit reinigen Rosmalen & Den Bosch | Hogedrukreiniging | Cleven Cleaning",
    metaDescription:
      "Oprit vol mos, olievlekken en groene aanslag? Cleven Cleaning reinigt klinkers, tegels en beton met hogedruk in Rosmalen, Den Bosch en omgeving. Vraag direct een prijs aan.",
    intro:
      "Uw oprit is het eerste wat bezoekers zien. Mos tussen de klinkers, olievlekken en groene aanslag halen wij met professionele hogedrukreiniging weg — voor een verzorgde entree van uw woning.",
    body: [
      "Klinkers, betontegels en gestort beton reinigen wij met een vlakreiniger op hoge druk, waardoor vuil, mos en algen gelijkmatig verdwijnen zonder strepen. Hardnekkige olie- of roestvlekken behandelen wij vooraf met een speciale reiniger.",
      "Na het reinigen vegen wij nieuw voegzand in en kunnen wij de oprit behandelen tegen nieuwe aanslag en onkruid. Zo blijft het resultaat langer zichtbaar.",
    ],
    benefits: [
      { title: "Mos en onkruid weg", text: "Ook tussen de voegen, waar borstelen niet lukt." },
      { title: "Vlekken behandeld", text: "Olie, roest en bandensporen krijgen een gerichte voorbehandeling." },
      { title: "Nieuw voegzand", text: "Wij vegen na afloop voegzand in voor stabiele klinkers." },
      { title: "Groot oppervlak, snel klaar", text: "Met professionele apparatuur reinigen wij tot honderden m² per dag." },
    ],
    faq: [
      { q: "Kunnen jullie ook olievlekken verwijderen?", a: "Verse vlekken meestal volledig; oude, ingetrokken olievlekken worden sterk verminderd. Wij geven vooraf eerlijk aan wat haalbaar is." },
      { q: "Hoe lang blijft mijn oprit schoon?", a: "Zonder nabehandeling gemiddeld 1 tot 2 jaar. Met een preventieve behandeling tegen algen en mos aanzienlijk langer." },
      { q: "Reinigen jullie ook paden en de stoep voor de woning?", a: "Ja, tuinpaden, achterompaden en de stoep nemen wij desgewenst direct mee." },
    ],
    related: ["terras-reinigen", "gevelreiniging", "schutting-reinigen"],
  },
  {
    slug: "gevelreiniging",
    title: "Gevel reinigen",
    category: "hogedruk",
    icon: "Building2",
    image: "action",
    h1: "Gevelreiniging: uw gevel weer als nieuw",
    metaTitle: "Gevelreiniging Rosmalen & Den Bosch | Cleven Cleaning",
    metaDescription:
      "Groene aanslag, vuil of witte uitslag op uw gevel? Cleven Cleaning reinigt metselwerk, stucwerk en gevelbekleding vakkundig in Rosmalen, Den Bosch en omgeving.",
    intro:
      "Een schone gevel maakt het verschil voor de uitstraling én waarde van uw pand. Wij reinigen metselwerk, stucwerk en gevelbekleding vakkundig, met de druk en techniek die bij uw gevel past.",
    body: [
      "Groene aanslag op de noordzijde, zwarte vervuiling door uitlaatgassen of witte kalkuitslag: elke gevel heeft zijn eigen probleem. Wij bekijken eerst het materiaal en de vervuiling en kiezen dan voor lage druk, stoom of een gerichte reiniger. Zo krijgt u een schoon resultaat zonder schade aan voegen of steen.",
      "Voor woningen, VvE's en bedrijfspanden werken wij tot 12 meter hoog zonder steiger. Na de reiniging kunnen wij uw gevel impregneren, zodat vuil en vocht minder snel hechten.",
    ],
    benefits: [
      { title: "Passend per materiaal", text: "Baksteen, stucwerk, hout of plaatmateriaal — elk krijgt de juiste methode." },
      { title: "Voegen blijven intact", text: "Nooit onnodig hoge druk op metselwerk." },
      { title: "Tot 12 meter hoog", text: "Zonder steiger of hoogwerker, dus geen extra kosten." },
      { title: "Optioneel impregneren", text: "Blijft langer schoon en beschermt tegen vocht." },
    ],
    faq: [
      { q: "Is hogedruk niet schadelijk voor mijn voegen?", a: "Op zachte voegen wel. Daarom testen wij altijd eerst op een klein stuk en werken wij op metselwerk met lage druk of stoom." },
      { q: "Kunnen jullie ook graffiti verwijderen?", a: "In veel gevallen wel, afhankelijk van de ondergrond en de verf. Wij beoordelen dit graag op locatie." },
      { q: "Wat is impregneren en is het nodig?", a: "Impregneren is een onzichtbare, waterafstotende beschermlaag. Het is niet verplicht, maar houdt uw gevel langer schoon en droog." },
    ],
    related: ["kozijnen-reinigen", "houtwerk-reinigen", "oprit-reinigen"],
  },
  {
    slug: "schutting-reinigen",
    title: "Schutting reinigen",
    category: "hogedruk",
    icon: "Fence",
    image: "vans",
    h1: "Schutting reinigen: groene aanslag verwijderen",
    metaTitle: "Schutting reinigen Rosmalen & Den Bosch | Cleven Cleaning",
    metaDescription:
      "Groene aanslag op uw houten of composiet schutting? Cleven Cleaning reinigt schuttingen en tuinafscheidingen in Rosmalen, Den Bosch en omgeving. Vraag direct een prijs aan.",
    intro:
      "Een groene, uitgeslagen schutting haalt uw hele tuin naar beneden. Wij reinigen houten en composiet schuttingen zorgvuldig, zodat de natuurlijke kleur terugkomt en het hout weer kan ademen.",
    body: [
      "Groene aanslag, mos en vuil trekken in het hout en houden vocht vast, waardoor de schutting sneller verweert. Wij reinigen op aangepaste druk met de houtnerf mee, zodat het hout niet ruw wordt of splintert. Composiet en betonnen schuttingen reinigen wij met de daarvoor geschikte techniek.",
      "Na het reinigen is de schutting klaar voor een nieuwe beits- of olielaag. Ook de betonnen onderplaten en palen nemen wij mee.",
    ],
    benefits: [
      { title: "Kleur komt terug", text: "Het originele hout wordt weer zichtbaar onder de aanslag." },
      { title: "Houtvriendelijk", text: "Aangepaste druk met de nerf mee, dus geen ruw of gesplinterd hout." },
      { title: "Klaar voor beits", text: "Een schone, droge ondergrond waar nieuwe beits perfect op hecht." },
      { title: "Beide zijden mogelijk", text: "In overleg met de buren reinigen wij de schutting aan twee kanten." },
    ],
    faq: [
      { q: "Wordt mijn schutting weer als nieuw?", a: "Groene aanslag en vuil verdwijnen volledig. Natuurlijke vergrijzing van onbehandeld hout wordt minder, maar verdwijnt niet helemaal; beitsen na reiniging geeft het mooiste resultaat." },
      { q: "Moet ik na het reinigen direct beitsen?", a: "Laat het hout eerst 2 tot 3 droge dagen drogen. Daarna is het het ideale moment om te beitsen of oliën." },
      { q: "Reinigen jullie ook tuinmeubelen en pergola's?", a: "Ja, houten en kunststof tuinmeubelen, pergola's en overkappingen nemen wij desgewenst mee." },
    ],
    related: ["terras-reinigen", "oprit-reinigen", "houtwerk-reinigen"],
  },
];

export const getServiceBySlug = (slug) => services.find((s) => s.slug === slug);

export const serviceIndex = services.map(({ slug, title, category }) => ({ slug, title, category }));
